import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MoEditableTitle extends Vue {
  @Prop({ required: false, default: 'h2' })
  tag: string
}
